import isEqual from "lodash/isEqual";
import { useState } from "react";

import FilterDropdownWrapper from "@/components/Elements/Filters/FilterDropdownWrapper";
import { FilterDropdownAttributes } from "@/components/Elements/Filters/Filters.type";
import ProgressBar from "@/components/Elements/ProgressBar";

const DEFAULT_VALUE = []; // default = reset filter
const FULL_RANGE = [0, 100];

import "./ProgressFilterDropdown.style.less";

// https://4x.ant.design/components/table/#components-table-demo-custom-filter-panel
const ProgressFilterDropdown = (filterProps) => {
  const { selectedKeys, setSelectedKeys, confirm } = filterProps;
  const [rangeValue, setRangeValue] = useState(selectedKeys ?? DEFAULT_VALUE);

  const onRangeChange = (value) => {
    // If full range is selected, just reset filter with empty array
    const cleanValue = isEqual(value, FULL_RANGE) ? DEFAULT_VALUE : value;
    setRangeValue(cleanValue);
  };

  const onResetClick = () => {
    setRangeValue(DEFAULT_VALUE);
  };

  const onOkClick = () => {
    setSelectedKeys(rangeValue);
    confirm();
  };

  const onDropdownClose = () => {
    // When dropdown is hidden, reset state to selectedKeys to make sure state
    // is always synced.
    setRangeValue(selectedKeys);
  };

  return (
    <FilterDropdownWrapper
      className="progress-filter-dropdown"
      filterProps={filterProps}
      okButtonProps={{ onClick: onOkClick }}
      resetButtonProps={{
        onClick: onResetClick,
        disabled: isEqual(rangeValue, DEFAULT_VALUE),
      }}
      onDropdownClose={onDropdownClose}
    >
      <ProgressBar
        range
        isEditable
        onChange={onRangeChange}
        value={rangeValue?.length ? rangeValue : FULL_RANGE}
      />
    </FilterDropdownWrapper>
  );
};

ProgressFilterDropdown.propTypes = FilterDropdownAttributes;

export default ProgressFilterDropdown;
